jQuery(document).ready(function($){
  
    var player = SC.Widget($('iframe.sc-widget')[0]);
    var scrub;
    var sc_playhead_lock = true;
    var pause = true;
    
    player.bind(SC.Widget.Events.PLAY_PROGRESS, function(e) {
      if( e.relativePosition < 0.003 ) { 
        setInfo(); 
      }
      if(!player.getPaused && !pause) {
        $('.sc-play').hide();
        $('.sc-pause').show();
      }
      //Event listener when track is playing
      if(!sc_playhead_lock) {
        $('.sc-position').css('width', ( e.relativePosition*100)+"%");
      }
    });
    
    $(document).on('keydown', function(e){
      switch(e.keyCode){
        case 32:
          player.toggle(); 
        break;
      }
    });
  
    $('.sc-player').click(function(e){ //Use the position to seek when clicked
      var pOffset = $('.sc-player').offset();
      scrub = (e.pageX-pOffset.left);
      $('.sc-position').css('width',scrub+"px");
      var pWidth = $('.sc-player').width();
      var seek = player.duration*(scrub/pWidth); 
      player.seekTo(seek);
      
    });
  
    $('body').on('click', '.sc-track-select', function(e) {
      e.preventDefault();
      $('.soundcloud-wrapper').hide();
      $('.sc-playlist-image').css('background-image', 'none');
  
      $('.sc-playlist-name').empty();
  
      if ($(this).data('sc-playlist-name')) {
        $('.sc-playlist-name').text($(this).data('sc-playlist-name'));
      }
      
      player.load($(this).data('sc-link'), { callback: function() {
      
        setInfo();
        $('.sc-waveform').css('background-image', "none");
        $('.soundcloud-wrapper').show();
        $('.sc-position').css('width', "0px");
        pause = false;
        player.play();
      }});
    });
  
    $('.sc-play').click(function() {
      pause = false;
      player.play();
    });
  
    $('.sc-pause').click(function() {
      player.pause();
      pause = true;
      $('.sc-pause').hide();
      $('.sc-play').show();
    });
  
    $('.sc-close').click(function() {
      player.pause();
      pause = true;
      $('.sc-play').show();
      $('.sc-pause').hide();    
      $('.soundcloud-wrapper').addClass('soundcloud-close');
      setTimeout(function() {
          $('.soundcloud-wrapper').hide();
          $('.soundcloud-wrapper').removeClass('soundcloud-close');
      }, 500);
    });
  
    $('.sc-next').click(function() {
      resetWaveForm();
      player.next();
      pause = false;
      setInfo();
    });
  
    $('.sc-prev').click(function() {
      resetWaveForm();
      player.prev();
      pause = false;
      setInfo();
    });
  
    $('body').on('change', '.sc-playlist-tracks', function() {
      resetWaveForm();
      var index = $('.sc-playlist-tracks').val();
      player.skip(index);
      setInfo();
    });
  
    function resetWaveForm() {
      player.pause();
      sc_playhead_lock = true;
      $('.sc-player').hide();
      $('.sc-waveform').css('-webkit-mask-box-image-source', "none"); 
      $('.sc-position').css('width', "0px"); 
    }
  
    
    
    function setInfo() {
      player.getCurrentSound(function(song) {
        // Soundcloud just borked this api endpoint, hence this hack :/
        
        var waveformPng =
            song.waveform_url
                .replace('json', 'png')
                .replace('wis', 'w1');
        
        var artworkUrl = song.artwork_url || '';
        
        $('.sc-waveform').css('-webkit-mask-box-image-source', "url('" + waveformPng + "')");    
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
          $('.sc-waveform').css('background-image', "url('" + waveformPng + "')");    
          $('.sc-waveform').css('background-position', "top");     
          $('.sc-waveform').css('background-size', "cover");    
        }
        $('.sc-playlist-image').css('background-image', "url('" + artworkUrl.replace('-large', '-t500x500') + "')");
        
        var info = song.title;
        player.getSounds(function (songs) {
          num_songs_in_playlist = songs.length;
          player.getCurrentSoundIndex(function(index) {
            current_song_index = index + 1;
            $('.sc-track-name').html(current_song_index + '/' + num_songs_in_playlist + ' ' + info).prop('title', info);
          });
        });
        
        sc_playhead_lock = false;
        player.current = song;
        setTimeout(function () {
          $('.sc-player').fadeIn();
        }, 200);
      });
      
      player.getDuration(function(value){
        player.duration = value;
      });
  
      player.getCurrentSoundIndex(function(index) {
        $('.sc-playlist-tracks').val(index);
      });
    }   
    
  });
  